import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const CreateCodeDialog = ({ state, onChange, onClose, onConfirm }) => {
  return (
    <Dialog open={state.open} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create Access Code</DialogTitle>
          <DialogDescription>
            Create a code that new users need to register. Leave code blank to auto-generate.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Code (optional — leave blank for auto-generated)</Label>
            <Input
              value={state.code}
              onChange={(e) => onChange({ ...state, code: e.target.value.toUpperCase() })}
              placeholder="e.g. WELCOME2026"
              className="font-mono uppercase"
              data-testid="new-code-input"
            />
          </div>
          <div className="space-y-2">
            <Label>Max Uses</Label>
            <Input
              type="number"
              min="1"
              value={state.maxUses}
              onChange={(e) => onChange({ ...state, maxUses: e.target.value })}
              data-testid="new-code-max-uses"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
          <Button onClick={onConfirm} data-testid="create-code-confirm">Create</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
